import React, { Fragment } from 'react'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import MultiOptions from './MultiOptions'
import Checkbox from 'components/AddOrEditFormPage/CustomForm/Checkbox'
import {
	ExpansionPanel,
	ExpansionPanelSummary,
	Typography,
	ExpansionPanelDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import Warning from './Warning'

const bool = ({ isEditing, isDragging, item, index }) =>
	isEditing ? (
		<div style={{ paddingTop: 10, paddingBottom: 10 }}>
			<Field
				label="Question"
				property="label"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].label
				}
				placeholder="Enter a question"
				sectionID={item.id}
			/>
			<Field
				label="Description"
				property="description"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].description
				}
				placeholder="Enter a description"
				sectionID={item.id}
			/>
			<MultiOptions bool itemID={item.id} />
			<Checkbox
				label="Required"
				property="required"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].field.required
				}
				type="field"
				sectionID={item.id}
			/>
			<ExpansionPanel>
				<ExpansionPanelSummary expandIcon={<ExpandMore />}>
					<Typography style={{ fontSize: 15 }}>Advanced</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ display: 'block' }}>
					<Checkbox
						label="Hidden"
						property="hidden"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].field.hidden ||
							false
						}
						type="field"
						sectionID={item.id}
					/>
					<Checkbox
						label="Read only"
						property="readonly"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].field.readonly ||
							false
						}
						type="field"
						sectionID={item.id}
					/>
					<Warning sectionID={item.id} />
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</div>
	) : (
		<>
			{item?.label && (
				<h3
					style={{
						marginBottom: 0,
						marginTop: '18.72px',
						fontSize: '18.72px',
						padding: 2,
					}}
				>
					{item.label || null}
					{item?.field?.required && <span style={{ color: 'red' }}>*</span>}
				</h3>
			)}
			{item?.description && (
				<div
					style={{
						marginBottom: 0,
						marginTop: '1.72px',
						fontSize: '12.72px',
						padding: 2,
					}}
				>
					{item.description}
				</div>
			)}
			<div className="vast_field_container">
				{item?.field?.field_options?.map?.((option, idx) => (
					<Fragment key={`custom-form-bool-${item.id}-${idx}`}>
						<input
							type="radio"
							value={option}
							name={item?.field?.field_name}
							datatype="select"
							id={`${idx}${item?.field?.field_name}`}
						/>
						<label htmlFor={`${idx}${item?.field?.field_name}`}>
							{idx === 0
								? item?.field?.boolean_labels?.true_label || 'yes'
								: item?.field?.boolean_labels?.false_label || 'no'}
						</label>
						<br />
					</Fragment>
				))}
			</div>
		</>
	)

export default bool
